import { Injectable } from '@angular/core';
import { HttpClient  } from '@angular/common/http';
import { Observable } from 'rxjs';

import * as theGlobals from '../shared/globals';

import { IHearingDate } from '../shared/classes/hearing-date';

@Injectable()
export class ScheduleService {

    private myUrl = theGlobals.setEnv().funcUrl;

    constructor(private http: HttpClient) {

    }
    // Schedule-related methods - rod
    getNeedSchedCaseList(): Observable<any[]> {
        const xUrl = this.myUrl + '/case/schedule';
        return this.http.get<any[]>(xUrl);
    }

    getHearingDates(): Observable<any[]> {
        const xUrl = this.myUrl + '/hearing';
        return this.http.get<any[]>(xUrl);
    }

    getHearingDate(hearingId: string): Observable<any> {
        const xUrl = this.myUrl + '/hearing/' + hearingId;
        return this.http.get<any[]>(xUrl);
    }

    getScheduledCases(hearingId: string): Observable<any[]> {
        const xUrl = this.myUrl + '/case/schedule/current/hearing/' + hearingId;
        return this.http.get<any[]>(xUrl);
    }

    getScheduledCasesAll(hearingId: string): Observable<any[]> {
        const xUrl = this.myUrl + '/case/schedule/hearing/' + hearingId;
        return this.http.get<any[]>(xUrl);
    }


    scheduleCaseForHearing(hearingId: string, cases: any[]): Observable<any> {
        const xUrl = this.myUrl + '/case/schedule/hearing/' + hearingId;
        return this.http.post(xUrl, cases);
    }

    moveCasesToHearing(hearingId: string, cases: any[]): Observable<any> {
        const xUrl = this.myUrl + '/case/reschedule/hearing/' + hearingId;
        return this.http.put(xUrl, cases);

    }
    getBoardMemberList(): Observable<any[]> {
        const xUrl = this.myUrl + '/boardmember';
        return this.http.get<any[]>(xUrl);
    }
    getMeetingLocations(): Observable<any> {
        const xUrl = this.myUrl + '/meetinglocation';
        return this.http.get<any>(xUrl);
    }

    saveHearingDate(hearing: IHearingDate): Observable<any> {
        const xUrl = this.myUrl + '/hearing';
        //console.log(hearing);
        if (!hearing.id) {
            return this.http.post(xUrl, hearing);
        }
        else {
            return this.http.put(xUrl + '/' + hearing.id, hearing);
        }
    }
    saveBoardMember(boardMember: any): Observable<any> {
        const xUrl = this.myUrl + '/boardmember';
        // alert('userId: '+user.id)
        if (!boardMember.id) {
            return this.http.post(xUrl, boardMember);
        } else {
            return this.http.put(xUrl + '/' + boardMember.id, boardMember);
        }
    }

    deleteBoardMember(boardMember: any): Observable<any> {
        const xUrl = this.myUrl + '/boardmember';
        return this.http.delete(xUrl + '/' + boardMember.id);
    }

    deleteHearingDate(hearingId: number): Observable<any> {
        const xUrl = this.myUrl + '/hearing';
        return this.http.delete(xUrl + '/' + hearingId);
    }

    // agenda related methods
    generateAgendaPdf(hearingId: number, hearType: string, isFinal: boolean = false):Observable<Blob>
    {
      let xUrl = "";
      if (isFinal) {
        xUrl = this.myUrl + '/agenda/generateagendafinal/hearing/' + hearingId;
      } else {
        xUrl = this.myUrl + '/agenda/generateagenda2/hearing/' + hearingId;
      }
      return this.http.get(xUrl,{ responseType: 'blob' });
    }
    generateAgendaSummaryPdf(hearingId: number, sortBy: string): Observable<Blob>
    {
      let xUrl = this.myUrl + '/agenda/agendasummary/hearing/' + hearingId + '/orderby/' + sortBy;
      return this.http.get(xUrl,{ responseType: 'blob' });
    }

  generateMinutesPdf(hearingId: number): Observable<Blob>
  {
    let xUrl = this.myUrl + '/minutes/hearing/' + hearingId ;
    return this.http.get(xUrl,{ responseType: 'blob' });
  }
  generateMinuteOrdersPdf(hearingId: number): Observable<Blob>
  {
    let xUrl = this.myUrl + '/minuteorders/' + hearingId ;
    return this.http.get(xUrl,{ responseType: 'blob' });
  }
  generateMinuteOrderLabels(hearingId: number): Observable<Blob>
  {
    let xUrl = this.myUrl + '/minuteorderlabels/' + hearingId ;
    return this.http.get(xUrl,{ responseType: 'blob' });

  }
}
